export default __webpack_public_path__ + "assets/7aa80383985193b5ee87eaf31bc163c4.svg";